module.exports = __webpack_public_path__ + "img/BrowserNotSupportedOutlined.687695d8.svg";